import React, { createContext, useState, useContext } from 'react';

const PannellumViewerContext = createContext(null);
function PannellumViewerProvider({ children, value, }) {
    const [viewerContext, setViewerContext] = useState(null);
    const mergeLinkedSpaceContext = (context) => {
        setViewerContext((viewerContext) => (Object.assign(Object.assign({}, viewerContext), context)));
    };
    return (React.createElement(PannellumViewerContext.Provider, { value: Object.assign(Object.assign(Object.assign({}, value), viewerContext), { setViewerContext: mergeLinkedSpaceContext }) }, children));
}
function usePannellumViewer() {
    return useContext(PannellumViewerContext);
}

export { PannellumViewerProvider, usePannellumViewer };
